import "../../../styles/responsiveRow.scss";

import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";

//import ResponsiveColumn from "./ResponsiveColumn";

const STYLE_CACHE = new Map();

/**
 * Cachear style-objekt givet bredd i andel (0 - 1)
 * @param {number} widthFraction 
 * @returns {object}
 */
function makeStyle(widthFraction) {
    let style = STYLE_CACHE.get(widthFraction);
    if (style) {
        return style;
    }

    style = {
        width: `${widthFraction * 100}%`
    };

    STYLE_CACHE.set(widthFraction, style);
    return style;
}

const FLEX_ROW_STYLE = {
    display: "flex",
    flexDirection: "row"
};

const mapStateToProps = state => {
    return {
        deviceType: state.view.deviceType
    };
};

class ResponsiveRows extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        let totalColumns = 0;

        const {columns,
            gutters,
            deviceType
        } = this.props;

        let currentRow = [];
        const rows = [];

        React.Children.forEach(this.props.children, (child) => {
            
            if (!child || !child.props) {
                return;
            }

            let {xs, sm, md, lg, xl} = child.props;

            xs = xs != null ? xs : 12;
            sm = sm != null ? sm : xs;
            md = md != null ? md : sm;
            lg = lg != null ? lg : md;
            xl = xl != null ? xl : lg;

            let columnWidth = 12;
            switch (deviceType) {
            case "xs":
                columnWidth = xs;
                break;
            case "sm":
                columnWidth = sm;
                break;
            case "md":
                columnWidth = md;
                break;
            case "lg":
                columnWidth = lg;
                break;
            case "xl":
                columnWidth = xl;
                break;
            }

            if (columnWidth >=1) {

                totalColumns += columnWidth;

                if (totalColumns >= columns) {
                    if (totalColumns === columns) {
                        currentRow.push(React.cloneElement(child, {
                            style: makeStyle(columnWidth / columns),
                            key: currentRow.length
                        }));
                    }

                    rows.push(
                        <div className="responsive-row" style={FLEX_ROW_STYLE} key={rows.length}>
                            {currentRow}
                        </div>
                    );
                    
                    currentRow = [];

                    if (totalColumns !== columns) {
                        currentRow.push(React.cloneElement(child, {
                            style: makeStyle(columnWidth / columns),
                            key: currentRow.length
                        }));
                    }

                    totalColumns = 0;
                } else {
                    currentRow.push(React.cloneElement(child, {
                        style: makeStyle(columnWidth / columns),
                        key: currentRow.length
                    }));
                }
            }
        });

        if (currentRow.length > 0) {
            rows.push(
                <div className="responsive-row" style={FLEX_ROW_STYLE} key={rows.length}>
                    {currentRow}
                </div>
            );
        }
        

        return (
            <div className={gutters ? "responsive-rows gutters" : "responsive-rows"}>
                {rows}
            </div>
        );
    }
}

ResponsiveRows.propTypes = {
    children: PropTypes.node,
    columns: PropTypes.number,
    deviceType: PropTypes.string.isRequired,
    gutters: PropTypes.bool
};

ResponsiveRows.defaultProps = {
    columns: 12,
    gutters: true
};

export default connect(mapStateToProps)(ResponsiveRows);